export type Auth_Modal_Mode = "login" | "signup";

export type Auth_Prompt_Detail = {
  Mode?: Auth_Modal_Mode;
  Next_Path?: string;
};

export const Auth_Event_Prompt = "parcelq:auth-prompt";
export const Auth_Event_Success = "parcelq:auth-success";

export function Auth_Prompt_Open(Detail: Auth_Prompt_Detail = {}): void {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new CustomEvent(Auth_Event_Prompt, { detail: Detail }));
}

export function Auth_Success_Notify(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new CustomEvent(Auth_Event_Success));
}
